module.exports = __webpack_public_path__ + "media/toolkits/COVID-mobile-ecosystem-2f3c3408.png";